import axios from 'axios';
import config from '../config';
import {createAuth} from "../Helpers";

const ALLERODNEWS_GET_RESPONSE = 'ALLERODNEWS_GET_RESPONSE';

const initialState = {
    news: []
};

export const actionCreators = {
    getNews: () => async(dispatch, getState) => {
        axios({
            method: 'GET',
            url: `${config.server}/api/adminOptions/allerod`,
            withCredentials: true,
            auth: createAuth(getState)
        }).then(response => {
            const data = response.data;
            dispatch({type: ALLERODNEWS_GET_RESPONSE, data: data});
        }).catch(error =>{

        });
    }
};

const reducerMethods = {
    ALLERODNEWS_GET_RESPONSE: (state, action) => {
        return{
            ...state,
            news: action.data
        }
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    const method = reducerMethods[action.type];
    if (method) return method(state, action);
    return state;
};